// Основной экспорт компонента
export { default } from './Documents.refactored';

// Экспорт типов
export * from './types';

// Экспорт хуков
export * from './hooks';
export * from './usePushNotifications';

// Экспорт утилит
export * from './utils';

// Экспорт отдельных компонентов
export { default as DocumentList } from './DocumentList';
export { default as DocumentFilters } from './DocumentFilters';
export { default as DocumentDialog } from './DocumentDialog';
export { default as DocumentViewDialog } from './DocumentViewDialog';
export { default as DocumentActions } from './DocumentActions';
export { default as PushNotificationManager } from './PushNotificationManager';
export { default as WarningAlertPanel } from './WarningAlertPanel';
export { default as BlockedNomenclatureDrawer } from './BlockedNomenclatureDrawer';
export { default as BoxQRPrintView } from './BoxQRPrintView';
export { default as BoxScanningView } from './BoxScanningView';

// Экспорт QR генератора
export * from './qrGenerator';
